import { SelectInput } from 'react-admin';
import { SearchBar } from '@/components/global/list/searchBar';
import { ReferenceArrayFilter } from '@/components/global/filters/filters.jsx';
import { collectionTypeChoices } from '@/components/global/options/selectOptions.jsx';
import FromToFilterComponent from '@/components/global/filters/FromToFilterComponent.jsx';
import { DateInput } from '@/components/global/inputs/DateInput.jsx';
import { deploymentStatusesFilters } from '@/components/newDevice/deploymentStatuses.js';

export const getNewDeviceFilters = (isMobile, translate) => [
    <SearchBar key='value' source='value' label={translate('common.search')} alwaysOn />,
    <SelectInput
        key='deploymentStatus'
        source='deploymentStatus'
        label={translate('resources.device.fields.deploymentStatus')}
        choices={deploymentStatusesFilters(translate)}
        emptyText={translate('common.all')}
        alwaysOn={isMobile}
    />,
    <DateInput
        className='date-input'
        key='productionDate_gte'
        source='productionDate_gte'
        label={translate('resources.device.labels.productionDateFrom')}
        alwaysOn={isMobile}
    />,
    <DateInput
        className='date-input'
        key='productionDate_lte'
        source='productionDate_lte'
        label={translate('resources.device.labels.productionDateTo')}
        alwaysOn={isMobile}
    />,
    <ReferenceArrayFilter
        key='groupId_in'
        source='groupId_in'
        reference='device-group'
        label={translate('common.group')}
        forceDesktopOnMobile={true}
        alwaysOn={isMobile}
    />,
    <ReferenceArrayFilter
        key='collectionPoint->id_in'
        source='collectionPoint->id_in'
        label={translate('common.collectionPoint')}
        reference='collection-point'
        optionText={choice => choice.customId}
        searchFields={['customId']}
        forceDesktopOnMobile={true}
        alwaysOn={isMobile}
    />,
    <SelectInput
        key='collectionType'
        source='collectionType'
        label={translate('resources.device.fields.collectionType')}
        choices={collectionTypeChoices(translate)}
        emptyText={translate('common.all')}
        alwaysOn={isMobile}
    />,
    <FromToFilterComponent
        key='createdAt'
        source='createdAt_range'
        label={translate('common.createdAtFilter')}
        type='date'
        forceDesktopOnMobile={true}
        alwaysOn={isMobile}
    />,
    <FromToFilterComponent
        key='updatedAt'
        source='updatedAt_range'
        label={translate('common.updatedAtFilter')}
        type='date'
        forceDesktopOnMobile={true}
        alwaysOn={isMobile}
    />,
];
